import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { ActivateComponent } from "./activate.component";
import { NewPasswordModule } from "../asset/newPassword/newPassword-form.module";

@NgModule({
    declarations: [
      ActivateComponent
    ],
    imports: [
      CommonModule,
      NewPasswordModule
    ],
    providers: [
    ]
})
export class ActivateModule { }



// WEBPACK FOOTER //
// /app/SPA/src/app/account/activate/activate.module.ts